import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION } from '../../../../constants/common'
import { AIButtonTextGrey } from '../../../AIButton'

import { QA_NAME_GRETA_AI_CHAT_PROJECTS_MORE } from './GretaAIChatChatListProjectsMore.constants'

import * as styles from './GretaAIChatChatListProjectsMore.module.css'

function GretaAIChatChatListProjectsMore({
  hiddenCount,
  isAllShown = false,
  onToggle = EMPTY_FUNCTION,
}) {
  const { t } = useTranslation()

  return (
    <AIButtonTextGrey
      className={styles.more}
      qaName={QA_NAME_GRETA_AI_CHAT_PROJECTS_MORE}
      text={
        isAllShown
          ? t('Greta.ProjectsShowLessKey')
          : t('Greta.ProjectsShowMoreKey', { count: hiddenCount })
      }
      onClick={onToggle}
    />
  )
}

export default GretaAIChatChatListProjectsMore
